module.exports = __webpack_public_path__ + "img/addPhoto.6c120291.svg";